import { render, staticRenderFns } from "./answerProgressUpgrade.vue?vue&type=template&id=6f27a5b6&scoped=true"
import script from "./answerProgressUpgrade.vue?vue&type=script&lang=js"
export * from "./answerProgressUpgrade.vue?vue&type=script&lang=js"
import style0 from "./answerProgressUpgrade.vue?vue&type=style&index=0&id=6f27a5b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f27a5b6",
  null
  
)

export default component.exports